export const defaultFilters = () => [
	{
		component: 'datepicker-range',
		label: 'Data de Criação',
		disabled: false,
		hidden: false,
		style: 'form-sale-dates',
		dateStart: '01/01/2012',
		params: {
			name: 'created_at',
			value: null,
		},
	},
	{
		component: 'datepicker-range',
		label: 'Data de Atualização',
		disabled: false,
		hidden: false,
		style: 'form-sale-dates',
		dateStart: '01/01/2012',
		params: {
			name: 'updated_at',
			value: null,
		},
	},
	{
		component: 'datepicker-range',
		label: 'Data de Venda',
		disabled: false,
		hidden: false,
		style: 'form-sale-dates',
		dateStart: '01/01/2012',
		params: {
			name: 'saled_at',
			value: null,
		},
	},
    {
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Reservas',
		disabled: false,
		hidden: false,
		load: false,
		itemLabel: 'item',
		searchAble: false,
		multiple: false,
		model: '',
		returnValue: 'value',
		options: [
			{ item: 'Todos', value: 3, id: 0 },
			{ item: 'Com reservas', value: 1, id: 1 },
			{ item: 'Sem reservas', value: 2, id: 2 },
		],
		params: {
			name: 'reserves',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: "Origens",
		disabled: false,
		hidden: false,
		service: 'origins',
		method: 'getOrigins',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		serviceParams: [],
		options: [],
		returnValue: 'id',
		groupBy: 'type',
		params: {
			name: 'origin_id',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'kanban-filter-origens'
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: "Canal",
		disabled: false,
		hidden: false,
		service: 'channels',
		method: 'getAllV2',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		options: [],
		groupBy: 'type',
		returnValue: 'id',
		serviceParams: [],
		searchEvent: 'channel-next-event',
		params: {
			name: 'channel_id',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'kanban-filter-channel'
	},

	{
		component: 'select-tags',
		ajaxSearch: false,
		label: "Tags",
		disabled: false,
		hidden: false,
		service: 'tag',
		method: 'getTagOptions',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		serviceParams: ['tags'],
		options: [],
		groupBy: 'type',
		returnValue: 'label',
		params: {
			name: 'tags',
			value: null
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'kanban-filter-tags',
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: "Empreendimentos",
		disabled: false,
		hidden: false,
		service: 'product',
		itemLabel: 'label',
		searchAble: true,
		multiple: true,
		method: 'getProductOptions',
		options: [],
		returnValue: 'id',
		params: {
			name: 'product_id',
			value: null
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,

	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: "Etapa",
		disabled: true,
		hidden: true,
		service: 'funnel',
		method: 'getStages',
		itemLabel: 'name',
		searchAble: false,
		multiple: false,
		handler: 'funnelStageHandler',
		options: [],
		returnValue: 'id',
		params: {
			name: 'funnel_stage_id',
			value: null
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Status',
		disabled: false,
		hidden: false,
		service: 'funnel',
		method: 'getStatus',
		itemLabel: 'name',
		searchAble: true,
		multiple: true,
		options: [],
		returnValue: 'id',
		groupBy: 'funnel_stage_name',
		params: {
			name: 'funnel_stage_status_id',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Ociosidade',
		disabled: true,
		hidden: false,
		service: 'idle',
		method: 'getAllV2',
		itemLabel: 'name',
		returnValue: 'id',
		searchAble: false,
		multiple: true,
		parse(data) {
			if (data && data.data) {
				return Object.values(data.data).map((option) => {
					let idle = option
					idle.stage = option.stage && option.stage.name ? option.stage.name : 'Regras atuais'
					idle.status = option.status && option.status.name ? option.status.name : 'Sem status'

					return idle
				})
			}
			return []
		},
		options: [],
		groupBy: 'stage',
		params: {
			name: 'idle_color_v2',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Tarefa',
		disabled: false,
		hidden: false,
		load: false,
		itemLabel: 'item',
		searchAble: false,
		multiple: false,
		model: '',
		returnValue: 'value',
		options: [
            { item: 'Todos', value: 2, id: 0 },
            { item: 'Com Tarefas Ativas', value: 1, id: 1 },
            { item: 'Com Tarefas Atrasadas', value: -1, id: 2 },
            { item: 'Sem Tarefas', value: 3, id: 3 }
		],
		params: {
			name: 'tasks',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Responsável',
		disabled: false,
		hidden: false,
		itemLabel: 'item',
		searchAble: true,
		multiple: false,
		options: [
			{ item: 'Todos', value: 'allDeals', id: 0 },
			{ item: 'Meus Clientes', value: 'myDeals', id: 1 },
			{ item: 'Acompanhando', value: 'followingDeals', id: 2 },
			{ item: 'Não Atribuídos', value: 'notAssigned', id: 3 },
		],
		returnValue: 'value',
		params: {
			name: 'owner',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Equipe',
		disabled: false,
		hidden: false,
		handler: 'teamHandler',
		service: 'team',
		method: 'getAll',
		itemLabel: 'name',
		searchAble: true,
		multiple: false,
		serviceParams: ['', { nocover: true, per_page: 1000 }],
		options: [],
		returnValue: 'id',
		params: {
			name: 'team_id',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Gerente',
		disabled: false,
		hidden: false,
		handler: 'managerHandler',
		itemLabel: 'first_name',
		searchAble: true,
		multiple: false,
		options: [],
		returnValue: 'manager_id',
		params: {
			name: 'manager_id',
			value: '',
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: false,
		label: 'Corretor',
		disabled: false,
		hidden: false,
		itemLabel: 'first_name',
		searchAble: true,
		multiple: false,
		options: [],
		returnValue: 'broker_id',
		params: {
			name: 'broker_id',
			value: null,
		},
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
	},
	{
		component: 'select-tags',
		ajaxSearch: true,
		label: 'Usuários',
		disabled: false,
		hidden: false,
		service: 'team',
		method: 'getAll',
		itemLabel: 'first_name',
		searchAble: true,
		multiple: false,
		options: [],
		returnValue: 'id',
		serviceParams: ['list/users', { nocover: true, per_page: 25, page: 1 }],
		params: {
			name: 'user_id',
			value: null,
		},
		requestOnStart: false,
		alreadyRequested: false,
		loading: false,
		openEvent: 'kanban-filter-users-sdr',
		searchEvent: 'kanban-search-users-sdr'
	},
]
export const defaultMenuCard = (procedureButtons = [], transferActive = false) => [
	{
		id: 1,
		title: 'Ações',
		itens: [
			{
				id: 1,
				title: 'Contatar o Cliente',
				action: 'modal-open-user-info',
				allowed_except: [],
				menu_allowed: null,
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Contatar o Cliente'
				}
			},
			{
				id: 2,
				title: 'Alterar Etapa e Status',
				action: 'modal-open-sales-deals-select-stage-status',
				allowed_except: [],
				menu_allowed: null,
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Alterar Etapa e Status'
				}
			},
			{
				id: 3,
				title: 'Alterar Responsáveis',
				action: 'modal-open-sales-deals-select-broker',
				allowed_except: ['broker'],
				menu_allowed: null,
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Alterar Responsáveis'
				}
			},
			{
				id: 4,
				title: 'Registrar Atendimento',
				action: 'modal-open-sales-deals-select-create-historical',
				allowed_except: [],
				menu_allowed: null,
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Registrar Atendimento'
				}
			},
			{
				id: 5,
				title: 'Solicitar Reserva de Unidade',
				action: 'modal-open-global--request-reserve',
				allowed_except: [],
				menu_allowed: 'reservas',
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Solicitar reserva de Unidade'
				}
			},
			// {
			// 	id: 6,
			// 	title: 'Simular Proposta',
			// 	action: 'go-to-proposal',
			// 	allowed_except: [],
			// 	menu_allowed: null,
			// },
			{
				id: 7,
				title: 'Criar Tarefa',
				action: 'modal-open-global--create-task',
				allowed_except: [],
				menu_allowed: null,
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Criar Tarefa'
				}
			},
			{
				id: 9,
				title: 'Duplicar Cliente',
				action: 'modal-open-duplicate-deal-modal',
				allowed_except: [],
				menu_allowed: null,
				gtm: {
				  event: 'fac_button_click',
				  category: 'vuejs-funil-vendas',
				  action: 'click',
				  label: 'Duplicar Cliente',
				},
			},
			...(transferActive ? [{
				id: 10,
				title: 'Transferência de Reserva',
				action: 'transfer.reservations',
				allowed_except: [],
				menu_allowed: null,
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Transferência de Reserva'
				}
			}] : []),
			{
				id: 8,
				title: 'Excluir',
				action: 'modal-open-delete-deal',
				allowed_except: [],
				menu_allowed: null,
				gtm: {
					event: 'fac_button_click',
					category: 'vuejs-funil-vendas',
					action: 'click',

					label: 'Excluir'
				}
			},
		],
	},
	{
		id: 2,
		title: 'Procedimentos',
		itens: [...procedureButtons],
	},
]
export const defaultParams = (data) => ({
	sortBy: {
		value: data.sort_by.value || 'updated_at',
		dir: data.sort_by.dir || 'desc'
	},
	search: data.search || '',
	page: data.page || 1,
	perPage: 25,
	filter: data.filters,
})
